<template>
  <main>
    <div class="selection_items">
      <div class="row">
        <div class="full column">
          <p class="descriptive-text">Receive further information on protective equipment by double-clicking on the respective product.</p>
        </div>
      </div>
      <ul>
        <li
          v-bind:key="item.id"
          v-for="item in scenarios"
          :class="[{hidden: item.id === 'bui-gloves' && which_level === 'logistics'}, {hidden: item.id === 'log-gloves' && which_level === 'construction'}, {hidden: item.id === 'log-gloves' && which_level != 'logistics'}, {active_item: item.title === item_copy_title}]"
          :data-target="item.target"
          :data-id="item.id"
        >
          <app-double-click
            v-lazy-container="{ selector: 'img', error: '/assets/icons/loading.svg', loading: '/assets/icons/loading.svg' }"
            @single-click="updateInfo(item.title, item.description, item.link, item.url)"
            @double-click="updateInfo(item.title, item.description, item.link, item.url)"
          >
            <img :data-src="item.url" alt />
            <img data-src="/assets/icons/ok.svg" :id="'img-'+item.id" alt class="hide_icon ok" />
          </app-double-click>
        </li>
        <li style="height:0px;"></li>
        <li style="height:0px;"></li>
      </ul>
    </div>
    <div class="selection_description">
      <div class="row">
        <div class="half column" style="padding: 4px; width: 70%;">
          <h2 style="word-break: break-word;">{{ item_copy_title }}</h2>
        </div>
        <div class="half column" style="width: 30%;">
          <img :src="item_img" class="description_img" alt />
        </div>
      </div>
      <div class="row">
        <div class="full column">
          <p>{{ item_description }}</p>
          <a
            class="primary_btn"
            target="_blank"
            v-if="item_link"
            :href="item_link"
          >{{ $t('buttons.see_product_button') }}</a>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import AppDoubleClick from "@/components/AppDoubleClick";

export default {
  name: "AppItemsSelector",
  props: ["scenarios"],
  components: {
    AppDoubleClick
  },
  data() {
    return {
      item_link: "",
      item_img: "",
      item_copy_title: "",
      item_description: "",
      which_level: ""
    };
  },
  methods: {
    updateInfo: function(title, description, link, url) {
      this.item_link = link;
      this.item_img = url;
      this.item_copy_title = title;
      this.item_description = description;
    }
  },
  beforeMount() {
    // console.log(this.scenarios);
    // console.log(this.scenarios.buiBoots);
    this.item_link = this.scenarios[0].link;
    this.item_img = this.scenarios[0].url;
    this.item_copy_title = this.scenarios[0].title;
    this.item_description = this.scenarios[0].description;
    this.which_level = this.$route.params.level;
  }
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}

/* Create two equal columns that floats next to each other */
.half {
  width: 50%;
}
.full {
  width: 100%;
}
.column {
  float: left;
  padding: 10px;
  background-color: #fff;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}
.hidden {
  display: none !important;
}
.active_item {
  filter: drop-shadow(7px 7px 7px #f2a900);
}
.hide_icon {
  display: none;
}
.correct_item {
  display: block !important;
}
.description_img {
  height: 62px;
}
li a {
  width: 100%;
  height: 100%;
}

.ok {
  width: 20px;
  height: 20px;
  margin: 0 auto;
  top: calc(66% - 20px);
  position: relative;
}

.descriptive-text {
  padding: 0 30px 0 30px;
}

@media (max-height: 700px) {
  .bg_glove_2 {
    top: 410px;
  }
  .bg_glove {
    top: 470px;
  }
  .bg_hardhat {
    top: 360px;
    left: 23px;
    width: 135px;
  }
}
</style>